var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/constants/log-level.ts
var LogLevel = {
  INFO: "INFO",
  ERROR: "ERROR",
  WARN: "WARN",
  DEBUG: "DEBUG"
};

// src/log-formatter.ts
var LogFormatter = class {
  static {
    __name(this, "LogFormatter");
  }
};

// src/logger.provider.ts
var LoggerProvider = class {
  constructor(logFormatter) {
    this.logFormatter = logFormatter;
  }
  static {
    __name(this, "LoggerProvider");
  }
};

// src/logger.service.ts
var LoggerService = class {
  constructor(loggerProvider) {
    this.loggerProvider = loggerProvider;
  }
  static {
    __name(this, "LoggerService");
  }
  log(logRecord) {
    this.loggerProvider.getLogger(logRecord.logger).log(logRecord);
  }
};
export {
  LogFormatter,
  LogLevel,
  LoggerProvider,
  LoggerService
};
//# sourceMappingURL=index.mjs.map